import React from "react";

import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  Tooltip,
  Checkbox,
  FormControlLabel,
  OutlinedInput,
  Divider,
  Typography,
} from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import { withSnackbar } from "../../../utils/common/SnackbarHoc";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";

// import { makeStyles } from "@mui/";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "../../common/SettingsAccordion";

import { enableAiSettingsModelArchitecture } from "../../../utils/config";
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  Preview,
} from "@mui/icons-material";
import { unescape } from "lodash";

interface IProps {
  name: string;
  accordionSettings: any;
  handleAccordionSettings: (name: string) => void;
  snackbarShowMessage: any;
  chatbotAISettings: any;
  setChatbotAISettings: (values: any) => void;
}

const PreAISettings = ({
  accordionSettings,
  handleAccordionSettings,
  name,
  chatbotAISettings,
  setChatbotAISettings,
}: IProps) => {
  const marks = [
    {
      value: 0,
      label: "0",
    },
    {
      value: 0.1,
      label: "1",
    },
    {
      value: 0.2,
      label: "2",
    },
    {
      value: 0.3,
      label: "3",
    },
    {
      value: 0.4,
      label: "4",
    },
    {
      value: 0.5,
      label: "5",
    },
    {
      value: 0.6,
      label: "6",
    },
    {
      value: 0.7,
      label: "7",
    },
    {
      value: 0.8,
      label: "8",
    },
    {
      value: 0.9,
      label: "9",
    },
    {
      value: 1,
      label: "10",
    },
  ];

  const handleTemplateChange = (e: any, key: string, index: number) => {
    const tempAISettings = { ...chatbotAISettings };
    let data = tempAISettings.intelligenceLayer[index];
    data = { ...data, [key]: e.target.value };
    data = { ...data, question_embedding: [] };
    tempAISettings.intelligenceLayer[index] = data;
    setChatbotAISettings(tempAISettings);
  };

  const handleAdditionalKnowledgeChange = (
    e: any,
    key: string,
    index: number
  ) => {
    const tempAISettings = { ...chatbotAISettings };
    let data = tempAISettings.intelligenceLayer[index];
    data = { ...data, [key]: e.target.checked };
    tempAISettings.intelligenceLayer[index] = data;
    setChatbotAISettings(tempAISettings);
  };

  const handleDisplayTicketChange = (e: any, key: string, index: number) => {
    const tempAISettings = { ...chatbotAISettings };
    let data = tempAISettings.intelligenceLayer[index];
    data = { ...data, [key]: e.target.checked };
    tempAISettings.intelligenceLayer[index] = data;
    setChatbotAISettings(tempAISettings);
  };

  const addTemplate = () => {
    const temp = { ...chatbotAISettings };
    const intelay = [
      ...chatbotAISettings.intelligenceLayer,
      { question: "", answer: "" },
    ];
    temp.intelligenceLayer = intelay;
    setChatbotAISettings(temp);
  };

  const deleteTemplate = (index: number) => {
    const temp: any = { ...chatbotAISettings };
    temp.intelligenceLayer.splice(index, 1);
    setChatbotAISettings(temp);
  };
  const handleAccordianChange = (value: any, type: any, clickType: any) => {
    handleAccordionSettings(type);
  };
  return (
    <Accordion
      expanded={accordionSettings[name]}
      onChange={() => handleAccordionSettings(name)}
    >
      <AccordionSummary aria-controls={"panel1-content"} id={"panel1-header"}>
        <Grid container className="acc-prod-icon">
          <Grid item spacing={2} className="acc-prod-icon">
            Pre AI Settings
          </Grid>
          <Grid item spacing={3} className="acc-prod-icon">
            <Tooltip
              title={
                <>
                  <Typography sx={{ fontSize: "12px" }}>
                    Personalized Chatbot Messages :
                  </Typography>
                  <Typography sx={{ fontSize: "11px" }}>
                    Created customized questions and answers
                  </Typography>
                </>
              }
              placement="bottom"
            >
              <HelpIcon sx={{ mx: 1, fontSize: "20px" }} />
            </Tooltip>
          </Grid>
          <Grid item sx={{ marginLeft: 2, display: "flex" }}>
            <Tooltip
              title="Click to view the playground preview"
              placement="bottom"
            >
              <Preview />
            </Tooltip>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          {chatbotAISettings?.intelligenceLayer?.map(
            (element: any, index: number) => {
              return (
                <>
                  <Grid
                    container
                    spacing={3}
                    sx={{ alignItems: "center", mb: 3, pl: "16px" }}
                    key={index}
                  >
                    <Grid item xs={11} sx={{ flexGrow: 1, mt: 1 }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <FormControl className="custom-select" fullWidth>
                            <InputLabel>
                              Custom Question
                              <div
                                style={{
                                  display: "inline-block",
                                  color: "red",
                                }}
                              >
                                *
                              </div>{" "}
                            </InputLabel>

                            <OutlinedInput
                              type="text"
                              id="question-select"
                              label="Question"
                              name="question"
                              value={unescape(element.question) || ""}
                              onChange={(e) =>
                                handleTemplateChange(e, "question", index)
                              }
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                          <FormControl className="custom-select" fullWidth>
                            <InputLabel>
                              Custom Answer
                              <div
                                style={{
                                  display: "inline-block",
                                  color: "red",
                                }}
                              >
                                *
                              </div>{" "}
                            </InputLabel>

                            <OutlinedInput
                              type="text"
                              id="answer-select"
                              label="Answer"
                              name="answer"
                              multiline
                              value={unescape(element.answer) || ""}
                              onChange={(e) =>
                                handleTemplateChange(e, "answer", index)
                              }
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          {" "}
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleAdditionalKnowledgeChange(
                                    e,
                                    "isAdditionalKnowledge",
                                    index
                                  )
                                }
                                checked={
                                  element.isAdditionalKnowledge ? true : false
                                }
                                color="primary"
                              />
                            }
                            label="Append this answer to the response from knowledgebase"
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          {" "}
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleDisplayTicketChange(
                                    e,
                                    "isDisplayTicket",
                                    index
                                  )
                                }
                                checked={element.isDisplayTicket ? true : false}
                                color="primary"
                              />
                            }
                            label="Display ticket creation form"
                          />
                        </Grid>
                        {!(
                          chatbotAISettings.intelligenceLayer.length - 1 ==
                          index
                        ) && (
                          <Grid item xs={12}>
                            <Divider style={{ borderStyle: "solid" }}></Divider>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                    <Grid item>
                      <>
                        <Tooltip
                          title="Delete Custom Question and Answer"
                          placement="top"
                        >
                          <CloseIcon
                            className="cursor-pointer"
                            onClick={() => deleteTemplate(index)}
                          />
                        </Tooltip>
                      </>
                    </Grid>
                  </Grid>
                </>
              );
            }
          )}
          <Grid
            item
            xs={12}
            sx={{
              marginBottom: "30px",
            }}
          >
            <Button
              fullWidth
              type="button"
              variant="contained"
              onClick={addTemplate}
              sx={{
                textTransform: "uppercase",
              }}
            >
              <AddIcon />
              Add a Question and Answer
            </Button>
          </Grid>
        </Grid>
        <Grid
          item
          sx={{ mt: 2, p: 0, mb: 0, lineHeight: 0 }}
          xs={12}
          md={12}
          className="acc-prod-footer"
        >
          <>
            {" "}
            <div></div>
          </>
          <Tooltip title="Go to AI Settings" placement="bottom">
            <Button
              size="small"
              className="nextbtn"
              onClick={(e: any) => {
                handleAccordianChange(true, "AISettings", "next");
              }}
            >
              &nbsp;<span className="acc-prod-next-span">Next :</span>&nbsp;{" "}
              <span>Go to AI Settings</span>
              <KeyboardArrowRight />
            </Button>
          </Tooltip>{" "}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default withSnackbar(PreAISettings);
